import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type ConnectSeamVisionlineUserRequest = {
  clientId: string
  seamUserId: string
}

const connectSeamVisionlineUser = async (data: ConnectSeamVisionlineUserRequest) => {
  const response = await authAPI.post(`/seam-visionline/users/${data.clientId}/connect`, {
    seamUserId: data.seamUserId,
  })
  return response.data
}

export const useConnectSeamVisionlineUser = () =>
  useMutation({
    mutationFn: connectSeamVisionlineUser,
  })
